import { api, endpoint } from "@/api";
import { flare } from "@flareapp/js";
import { Button, Form, Modal, Select } from "antd";
import axios from "axios";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Swal from "sweetalert2";

const initState = {
  siteLocation: "",
  siteUser: [],
  dashboard: "",
  dashboardType: "",
  business: "",
};

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

const DefaultDashboardModal = ({ open, setOpen, selectedUser, getUsers }) => {
  const [form] = Form.useForm();

  const [businessesList, setBusinessesList] = useState([]);
  const [locations, setLocations] = useState([]);
  const [dashboardList, setDashboardList] = useState([]);

  const [formData, setFormData] = useState(initState);
  const { business, siteLocation, dashboard } = formData;

  const handleOk = () => {
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    // form.resetFields();
  };
  const getBusiness = async () => {
    try {
      const data = await api.get(endpoint.business);
      setBusinessesList(data?.data);
      if (Array.isArray(data?.data) && data.data.length === 1) {
        setFormData({ ...formData, business: data.data[0]._id });
        if (data?.data?.length === 1) {
          form.setFieldsValue({ business: data?.data[0]._id });
          getLocation(data?.data[0]._id);
        }
      }
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.log("site location", error);
    }
  };

  const getLocation = async (business) => {
    const response = await axios.get(`/site-location/my-site`, {
      withCredentials: true,
      params: {
        business,
        limit: 100,
      },
    });
    setLocations(response?.data);
  };

  const getDashboardList = async (siteLocation) => {
    // setIsLoading(true);
    const response = await api.get(endpoint.get_dashboard_list, {
      params: {
        // deviceId: device,
        business: business,
        site: siteLocation,
        limit: 1000,
        page: 1,
      },
    });
    setDashboardList(response?.data || []);
    // setIsLoading(false);
  };

  // submit
  const handleSubmit = async () => {
    try {
      const { dashboard } = formData;

      const body = {
        userId: selectedUser?._id,
        dashboardId: dashboard,
        isActive: Boolean(dashboard),
        business: business,
        site: siteLocation,
      };
      const { success } = await api.put(endpoint.active_dashboard, body);
      if (success) {
        await Swal.fire({
          title: "Success!",
          text: "Dashboard successfully made default for user!",
          icon: "success",
          timer: 1500,
        });
      }
      await getUsers();
    } catch (error) {
      flare.report(error);
      // eslint-disable-next-line no-console
      console.error(error);
    } finally {
      handleCancel();
    }
  };

  useEffect(() => {
    if (business) {
      getLocation(business);
    }
  }, [business]);

  useEffect(() => {
    if (siteLocation) {
      getDashboardList(siteLocation);
    }
  }, [siteLocation]);

  useEffect(() => {
    if (open) {
      getBusiness();
    }
  }, [open]);

  useEffect(() => {
    const updatedFromData = {
      dashboard: selectedUser?.defaultDashboard?.dashboardId,
      business: selectedUser.defaultDashboard?.business || selectedUser?.business?.[0],
      siteLocation: selectedUser.defaultDashboard?.site || selectedUser?.site?.[0],
      isActive: dashboard === selectedUser.defaultDashboard?.dashboardId,
    };

    form.setFieldsValue(updatedFromData);
    setFormData(updatedFromData);

    if (selectedUser.defaultDashboard?.business || selectedUser?.business?.length === 1) {
      getLocation(selectedUser.defaultDashboard?.business || selectedUser?.business[0]);
    }
    if (selectedUser.defaultDashboard?.site || selectedUser?.site?.length === 1) {
      getDashboardList(selectedUser.defaultDashboard?.site || selectedUser?.site[0]);
    }
  }, [selectedUser, business]);

  // dashboard list
  const dashboardOptions = dashboardList?.map((item) => ({ label: item.name, value: item._id })) || [];

  return (
    <Modal open={open} title="Title" onOk={handleOk} onCancel={handleCancel} footer={false}>
      <Form
        layout="vertical"
        name="users"
        onFinish={handleSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
        initialValues={{}}
      >
        <Row>
          <Col md={12}>
            {/* business */}
            <Form.Item
              label="Business"
              name="business"
              rules={[{ required: true, message: "Please select a business!" }]}
            >
              <Select
                showSearch
                className="text-secondary w-100"
                onChange={(business) => setFormData({ ...formData, business })}
                value={formData.business || undefined}
                placeholder="Select Business"
                disabled={selectedUser?.business?.length === 1}
                options={
                  businessesList?.map((item) => ({
                    label: `${item.name} (${item.id})`,
                    value: item._id,
                  })) || []
                }
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              />
            </Form.Item>
          </Col>

          {/* location */}
          <Col md={12}>
            <Form.Item
              label="Locations"
              name="siteLocation"
              rules={[{ required: true, message: "Please select a location!" }]}
            >
              <Select
                className="text-secondary"
                onChange={(value) => setFormData({ ...formData, siteLocation: value })}
                value={formData.siteLocation}
                placeholder="Select Site Location"
                showSearch
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                options={
                  locations?.map((item) => ({
                    label: item.name,
                    value: item._id,
                  })) || []
                }
              />
            </Form.Item>
          </Col>

          {/* dashboard */}
          <Col md={12}>
            <Form.Item
              label="Dashboard"
              name="dashboard"
              // rules={[{ required: true, message: "Please select a dashboard!" }]}
            >
              <Select
                className="text-secondary"
                // value={formData.dashboard}
                showSearch
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                onChange={(value) => setFormData({ ...formData, dashboard: value })}
                placeholder="Select Dashboard"
                options={[{ label: "Select Dashboard", value: null }, ...dashboardOptions]}
              />
            </Form.Item>
          </Col>

          {/* isActive */}
          {/* <Col md={12}>
            <Form.Item
              layout="horizontal"
              label="Default Dashboard"
              name="isActive"
              colon={false}
              className="right-label mb-0"
            >
              <Switch onChange={(isActive) => setFormData({ ...formData, isActive })} />
            </Form.Item>
          </Col> */}

          <Col xs={12} className="d-flex justify-content-end gap-2">
            <Button type="primary" htmlType="submit" className="px-4">
              Assign
            </Button>
            <Button onClick={handleCancel} danger htmlType="button" className="px-4">
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default DefaultDashboardModal;

DefaultDashboardModal.propTypes = {
  setOpen: PropTypes.func,
  getUsers: PropTypes.func,
  open: PropTypes.Boolean,
  selectedUser: PropTypes.object,
};
